import React from 'react';
import PropTypes from 'prop-types';
// import Img from 'gatsby-image';
import Helmet from 'react-helmet';
import Head from '../components/Head';
import ContactForm from '../components/contact';

export default function Template() {
  return (
    <div>
      <Helmet title={`Next - How we work`} />

      <div className="hero is-relative is-theme-secondary hero-waves">
        <Head />
        <div id="main-hero" className="hero-body ">
          <div className="container">
            <div className="columns is-vcentered is-tablet-portrait">
              <div className="column is-7 header-caption has-text-left">
                <h1 className="landing-title">Discover How We Deliver Your Products</h1>
                <h2 className="subtitle is-7 light-text">
                  We build client relationships on trust. We openly share all of our work methods and the rules we rely on.
                </h2>
                <p className="pt-10 pb-10">
                  <a href="#contact-form" className="button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2">
                    Hire Us
                  </a>
                </p>
              </div>
              <div className="column is-9 is-offset-1 is-hidden-mobile">
                <figure className="image is-4by3 reactjs-logo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="features" className="section is-medium">
        <div className="container has-text-centered">
          <div className="section-title-wrapper has-text-centered">
            <div className="bg-number">
              <i className="fas fa-cogs" />
            </div>
            <h2 className="section-title-landing">Process of work</h2>
          </div>
          <div className="content-wrapper">
            <div className="columns is-vcentered has-text-centered">
              <div className="column is-12">
                <ol className="simple-feed sprint">
                  <li className="feed-item">
                    <i className="is-icon-2x accent-text">01</i>
                    <div className="feed-item-text content has-text-left">
                      <h2>Kickoff</h2>
                      At Next, successful kickoff means getting to the bottom of user expectations and needs before project designing and development.
                    </div>
                  </li>

                  <li className="feed-item">
                    <i className="is-icon-2x accent-text">02</i>
                    <div className="feed-item-text content has-text-left">
                      <h2>Product Development</h2>
                      We repeat the process over and over to get your idea into the shape. We use Scrum to make our work efficient and valuable. The key
                      elements of Scrum are:-
                      <img className="sprint-image mt-30 mb-10 is-hidden-mobile" src="/files/images/illustrations/UI/sprint.png" />
                    </div>
                  </li>

                  <li className="feed-item disable-dot">
                    <div className="feed-item-text content has-text-left">
                      <div className="container">
                        <div className="content-wrapper">
                          <div className="columns is-vcentered">
                            <div className="column is-4">
                              <div className="content content-flex">
                                <div className="dark-text has-text-left">
                                  <h2 className="is-landing pt-5 pb-5">Scrum Planning</h2>
                                  With you plan which features to be included in the product and then implement them. We plan work in intervals called Sprints
                                  which usually lasts 2 weeks.
                                </div>
                              </div>
                            </div>
                            <div className="column is-4">
                              <div className="content content-flex">
                                <div className="dark-text has-text-left">
                                  <h2 className="is-landing pt-5 pb-5">Scrum Implementation</h2>
                                  We divide our work into small parts so that our efforts can be seen individually in each sprint. Every sprint delivers a
                                  different piece of work.
                                </div>
                              </div>
                            </div>

                            <div className="column is-4">
                              <div className="content content-flex">
                                <div className="dark-text has-text-left">
                                  <h2 className="is-landing pt-5 pb-5">Retrospective</h2>
                                  Transparency is the thing we value the most. Every sprint we adapt to change and strive to make it better.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="section section-feature-grey is-medium">
        <div className="container has-text-centered">
          <div className="section-title-wrapper has-text-centered">
            <div className="bg-number">1</div>
            <h2 className="section-title-landing">Transparency</h2>
            <h4>We guarantee transparency on every step of our way, to gain your trust.</h4>
          </div>
          <div className="content-wrapper">
            <div className="columns is-vcentered has-text-centered">
              <div className="column is-hidden-mobile" />
              <div className="column is-3">
                <div className="square-icon-box is-landing secondary">
                  <div className="icon-box-wrapper">
                    <div className="icon-box">
                      <i className="fas fa-stopwatch" />
                    </div>
                  </div>
                  <div className="box-title">Time contract & Accurate time logs</div>
                  <div className="box-text is-tablet-padded">
                    You only pay for the amount of time our project team has worked for you and you can check the time logs anytime you need.
                  </div>
                </div>
              </div>
              <div className="column is-3">
                <div className="square-icon-box is-landing secondary">
                  <div className="icon-box-wrapper">
                    <div className="icon-box">
                      <i className="far fa-edit" />
                    </div>
                  </div>
                  <div className="box-title">NDA on request</div>
                  <div className="box-text is-tablet-padded">
                    We understand that you may want to hide your ideas in all ways possible, therefore, we agree to sign NDA&apos;s.
                  </div>
                </div>
              </div>
              <div className="column is-3">
                <div className="square-icon-box is-landing primary">
                  <div className="icon-box-wrapper">
                    <div className="icon-box">
                      <i className="fas fa-headset" />
                    </div>
                  </div>
                  <div className="box-title">Direct access to Development Environment</div>
                  <div className="box-text is-tablet-padded">
                    You can clearly see what&apos;s going on under the hood, anytime, to make sure everything is according to your taste and ideas.
                  </div>
                </div>
              </div>
              <div className="column is-3">
                <div className="square-icon-box is-landing primary">
                  <div className="icon-box-wrapper">
                    <div className="icon-box">
                      <i className="fas fa-globe-americas" />
                    </div>
                  </div>
                  <div className="box-title">Time zones are not a problem</div>
                  <div className="box-text is-tablet-padded">
                    You may think that time difference may create a problem, but fear not, planned sessions, weekly calls and communicative channels do the
                    needful.
                  </div>
                </div>
              </div>
              <div className="column is-hidden-mobile" />
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="section is-medium">
        <div className="container has-text-centered">
          <div className="section-title-wrapper has-text-centered">
            <div className="bg-number">1</div>
            <h2 className="section-title-landing">Tools of Trade</h2>
            <h4>The tools through which we communicate are based on the needs of the projects. Here ae some tools which we use frequently:-</h4>
          </div>
          <div className="content-wrapper">
            <div className="columns is-vcentered has-text-centered">
              <div className="column is-one-third">
                <div className="feature-card card-lg light-bordered hover-inset has-text-centered mb-20">
                  <div className="card-icon">
                    <img src="/files/images/illustrations/icons/slack.svg" alt="" />
                  </div>
                  <div className="card-title">
                    <h4>Slack</h4>
                    <h5>Real communication tool</h5>
                  </div>
                  <div className="card-feature-description">
                    <span className="">
                      Real communication tool for the clients and the team. Every project has a dedicated private channel to discuss their work. This way your
                      project info is both private and transparent at the same time.
                    </span>
                  </div>
                </div>
              </div>
              <div className="column is-one-third">
                <div className="feature-card card-lg light-bordered hover-inset has-text-centered mb-20">
                  <div className="card-icon">
                    <img src="/files/images/illustrations/icons/jira.svg" alt="" />
                  </div>
                  <div className="card-title">
                    <h4>JIRA</h4>
                    <h5>Project management software</h5>
                  </div>
                  <div className="card-feature-description">
                    <span className="">
                      Here you can see the current status of your project, past doings and future planings. Also, from here you can check time logs and progress
                      in you project.
                    </span>
                  </div>
                </div>
              </div>
              <div className="column is-one-third">
                <div className="feature-card card-lg light-bordered hover-inset has-text-centered mb-20">
                  <div className="card-icon">
                    <img src="/files/images/illustrations/icons/confluence.svg" alt="" />
                  </div>
                  <div className="card-title">
                    <h4>Confluence</h4>
                    <h5>Knowledge base kept in Confluence</h5>
                  </div>
                  <div className="card-feature-description">
                    <span className="">
                      Here&apos;s where we keep plans, retrospectives, documentation and other know-how pieces for everyone to know, for the smooth running of
                      the project.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="columns is-vcentered has-text-centered">
              <div className="column is-one-third is-offset-2-desktop">
                <div className="feature-card card-lg light-bordered hover-inset has-text-centered mb-20">
                  <div className="card-icon">
                    <img src="/files/images/illustrations/icons/google-suite.svg" alt="" />
                  </div>
                  <div className="card-title">
                    <h4>G Suite</h4>
                    <h5>Utilisation of tools from Google</h5>
                  </div>
                  <div className="card-feature-description">
                    <span className="">
                      To share information we utilise tools from Google. The video calls are handles via Hangouts and the documents are shared via Drive- in
                      folders with accurate accessibility for Next and its client&apos;s team.
                    </span>
                  </div>
                </div>
              </div>
              <div className="column is-one-third">
                <div className="feature-card card-lg light-bordered hover-inset has-text-centered mb-20">
                  <div className="card-icon">
                    <img src="/files/images/illustrations/icons/github.svg" alt="" />
                  </div>
                  <div className="card-title">
                    <h4>Github</h4>
                    <h5>A place to share and store send code with world by developers </h5>
                  </div>
                  <div className="card-feature-description">
                    <span className="">
                      A global platform that enables you to collaborate and present your work instantly, no matte what platform you work on.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>
    </div>
  );
}

Template.propTypes = {
  data: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/pages/how-we-work.jsx